/* eslint-disable */
import React, { useEffect, useContext, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { parseString } from 'utils/parseString';
import { ModalContext } from 'App';
import * as actions from '../../cms/action';
import * as c from '../../cms/constant';

export const PAPER_SIZES = [
  { label: 'A4 Size', value: 'a4' },
  { label: 'Legal Size', value: 'legal' },
  { label: 'Long Size', value: 'long' },
  { label: 'Letter Size', value: 'letter' },
];

export const PAPER_ORIENTATION = [
  { label: 'Portrait', value: 'portrait' },
  { label: 'Landscape', value: 'landscape' },
];

export const PAPER_MARGIN = [
  { label: 'Inches', value: 'in' },
  { label: 'Centimeters', value: 'cm' },
  { label: 'Millimeters', value: 'mm' },
];

function CreatePaperSetupModal({
  createInput,
  createSelect,
  formData,
  setFormData,
  update,
  updating,
  parsedData,
  defaultPaperSetup,
  cmsId,
  getList,
}) {
  const setModal = useContext(ModalContext);
  const body = _.get(parsedData, 'body', '[]');
  const dataBody = useMemo(() => {
    const parsedBody = parseString(body);
    return parsedBody;
  }, [body]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (cmsId && !isEmpty(body)) {
      const payloadBody = dataBody.map((i) => ({
        ...i,
        paper_setup: formData,
      }));
      update(
        cmsId,
        { body: JSON.stringify(payloadBody) },
        (res) => {
          const type = _.get(res, 'data.attributes.type', '');
          getList({ type });
          setModal({ isOpen: false });
        }
      );
    }
  };

  useEffect(() => {
    setFormData(defaultPaperSetup);
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Paper Size',
                key: 'paper_size',
                label: 'Paper Size',
              },
              PAPER_SIZES
            )}
          </div>
          <div className="col-12 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Paper Orientation',
                key: 'paper_orientation',
                label: 'Paper Orientation',
              },
              PAPER_ORIENTATION
            )}
          </div>
          <div className="col-12 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Paper Margin',
                key: 'paper_margin',
                label: 'Paper Margin',
              },
              PAPER_MARGIN
            )}
          </div>

          <div className="col-12 form-group">
            {createInput(
              { key: 'top', label: 'Top' },
              { required: true, placeholder: 'Top' }
            )}
          </div>

          <div className="col-12 form-group">
            {createInput(
              { key: 'left', label: 'Left' },
              { required: true, placeholder: 'Left' }
            )}
          </div>

          <div className="col-12 form-group">
            {createInput(
              { key: 'bottom', label: 'Bottom' },
              { required: true, placeholder: 'Bottom' }
            )}
          </div>

          <div className="col-12 form-group">
            {createInput(
              { key: 'right', label: 'Right:' },
              { required: true, placeholder: 'right' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary ml-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreatePaperSetupModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  defaultPaperSetup: PropTypes.instanceOf(Object).isRequired,
  cmsId: PropTypes.number.isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreatePaperSetupModal);
